module.exports = __webpack_public_path__ + "img/1F1F3-1F1F4.f1481f73.svg";